module.exports = __webpack_public_path__ + "img/bid_img1.b9f4a1b0.jpg";